// eslint-disable-next-line no-restricted-imports
import { captureException as baseCaptureException } from '@sentry/react';
import type { Primitive } from 'type-fest';

import { Codeowners } from 'components/Common/Error/Codeowners';

export function captureException(error: unknown, codeOwners: Codeowners, tags?: Record<string, Primitive>) {
  baseCaptureException(error, {
    tags: { codeowners: codeOwners, ...tags },
  });

  return error;
}
